import { render, staticRenderFns } from "./backBtn.vue?vue&type=template&id=aa0d3876&scoped=true&"
import script from "./backBtn.vue?vue&type=script&lang=js&"
export * from "./backBtn.vue?vue&type=script&lang=js&"
import style0 from "./backBtn.vue?vue&type=style&index=0&id=aa0d3876&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0d3876",
  null
  
)

export default component.exports